/**
 * Shared watchlist notification content used across multiple components:
 * - Action Reports (Desktop/Mobile)
 * - TreeView (LOS modal)
 */
const content = {
  notification: {
    added: "{name} was added to your Watchlist.",
    removed: "{name} was removed from your Watchlist.",
    error: "Something went wrong. Please try again.",
  },
};

export default content;
